<template>
  <div>
    <p>
      Sobald du einen Raum erstellt hast oder einem beigetreten bist, wird
      dieser hier aufgelistet.
    </p>
    <p>
      {{isTouchDevice ? 'Tippe' : 'Klicke'}} auf einen Raum um in diesen zu wechseln.<br>
      Im nächsten Schritt wechseln wir in den "Beispielraum".
    </p>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {switchRoom} from './step-utils';
  import {routeOptions, isTouchDevice} from '../../assets/js/utils';


  const component = {
    name: 'StepRoomChange',

    data: () => ({
      isTouchDevice
    })
  };


  export const StepRoomChange = {
    target: '[room-id="example-room"]',
    before: async () => {
      await switchRoom('local');

      Vue.store.commit('share/updateTour', {exampleRoom: true});
      await Vue.router.replace(routeOptions({path: '/share/rooms'}));

      // Wait until dialog is created.
      await new Promise((resolve) => Vue.nextTick(resolve));

      // Wait until dialog animation is done.
      await new Promise((resolve) => setTimeout(resolve, 200));

      // Wait until rooms are loaded.
      await new Promise((_resolve) => {
        let interval, timeout;
        const resolve = () => {
          clearInterval(interval);
          clearTimeout(timeout);
          _resolve();
        };

        // Check if rooms are loaded.
        interval = setInterval(() => {
          if (document.querySelector(StepRoomChange.target)) {
            resolve();
          }
        }, 100);

        // Fix if loading rooms failed or lasts to long.
        timeout = setTimeout(resolve, 5000);
      });
    },
    after: async () => {
      Vue.store.commit('share/updateTour', {exampleRoom: false});
    },
    header: 'Raum wechseln',
    content: component
  };


  export default component;
</script>
